module.exports = __webpack_public_path__ + "img/guide_c.af261095.svg";